{
  "removeButtonLabel": "Odstrániť",
  "removeDescription": "Ak chcete odstrániť značku, stlačte kláves Delete."
}
